import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import OnBoardingSidebar from "../../../../components/CoachFlow/OnBoarding/Sidebar/Sidebar";
import classes from "./OnBoardingScreen.module.css";
import PersonalInfo from "../../../../components/CoachFlow/OnBoarding/PersonalInfo/PersonalInfo";
import BackgroundCheck from "../../../../components/CoachFlow/OnBoarding/BackgroundCheck/BackgroundCheck";
import SetYourLesson from "../../../../components/CoachFlow/OnBoarding/SetYourLesson/SetYourLesson";
import Address from "../../../../components/CoachFlow/OnBoarding/Address/Address";
import AddFaq from "../../../../components/CoachFlow/OnBoarding/AddFaq/AddFaq";
import StartWorkAndGetPaid from "../../../../components/CoachFlow/OnBoarding/StartWorkAndGetPaid/StartWorkAndGetPaid";
import SetAvailablity from "../../../../components/CoachFlow/OnBoarding/SetAvailability/SetAvailablity";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import { useLocation } from "react-router-dom";

export default function OnBoardingScreen() {
  const location = useLocation()?.state
  const [parentStep, setParentStep] = useState(location ? location?.mainStep : 1);
  const [childStep, setChildStep] = useState(location ? location?.childStep : 1);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    isMobileViewHook(setIsMobile,992);
  }, []);

  function stepForwardAndBackward(p, c) {
    setParentStep(p);
    setChildStep(c);
  }

  return (
    <div className={`${[classes.onBoardingScreen].join(" ")}`}>
      <Container fluid className={classes.container}>
        <Row className="g-0">
          <Col xl={3} lg={3} md={isMobile ? 0 : 4} className={classes.hide}>
            <OnBoardingSidebar
              parentStep={parentStep}
              setParentStep={setParentStep}
              childStep={childStep}
              setChildStep={setChildStep}
            />
          </Col>
          <Col xl={9} lg={9} md={isMobile ? 12 : 8} sm={12}>
            {parentStep === 1 &&
              ((childStep === 1 && (
                <PersonalInfo stepForwardAndBackward={stepForwardAndBackward} />
              )) ||
                (childStep === 2 && (
                  <BackgroundCheck
                    stepForwardAndBackward={stepForwardAndBackward}
                  />
                )))}
            {parentStep === 2 &&
              ((childStep === 1 && (
                <SetYourLesson
                  stepForwardAndBackward={stepForwardAndBackward}
                />
              )) ||
                (childStep === 2 && (
                  <Address stepForwardAndBackward={stepForwardAndBackward} />
                )) ||
                (childStep === 3 && (
                  <AddFaq stepForwardAndBackward={stepForwardAndBackward} />
                )) ||
                (childStep === 4 && (
                  <StartWorkAndGetPaid
                    stepForwardAndBackward={stepForwardAndBackward}
                  />
                )))}
            {parentStep === 3 && (
              <SetAvailablity stepForwardAndBackward={stepForwardAndBackward} />
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
